import { render, staticRenderFns } from "./BzVideoPlayer.vue?vue&type=template&id=e72193e6"
import script from "./BzVideoPlayer.vue?vue&type=script&lang=js"
export * from "./BzVideoPlayer.vue?vue&type=script&lang=js"
import style0 from "./BzVideoPlayer.vue?vue&type=style&index=0&id=e72193e6&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports